import { client, errorValidation } from "./service";

export const getBanner = async function () {
    try {
        let response = await client.get(`/banner`);
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data, error: null };
    } catch (e) {
        return { data: null, ...errorValidation(e) }
    }
}

export const getAboutUs = async function () {
    try {
        let response = await client.get(`/about-us`);
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data, error: null };
    } catch (e) {
        return { data: null, ...errorValidation(e) }
    }
}